export default "__VITE_ASSET__fe8ab924__"